var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.665 4.969c0-2.74-2.23-4.969-4.97-4.969a4.975 4.975 0 00-4.968 4.969H0V16.77a3.106 3.106 0 003.106 3.106h11.18a3.106 3.106 0 003.105-3.106V4.97h-3.726zm-4.97-3.727a3.73 3.73 0 013.727 3.727H4.97a3.73 3.73 0 013.727-3.727zm5.59 17.392a1.865 1.865 0 001.864-1.864V6.211h-2.484v1.864a.621.621 0 11-1.243 0V6.21H4.97v1.864a.621.621 0 11-1.242 0V6.21H1.242v10.56c0 1.027.836 1.863 1.864 1.863h11.18z",
    clipRule: "evenodd"
  })));
}

export default SvgBag;